import { FontFamilyOption } from 'globalStyles';
import { replaceHttpWithHttps } from './functions';

export const generateFontFaces = (fonts: FontFamilyOption[]): string => {
  if (!fonts || fonts.length === 0) return '';

  const fontFaces: string[] = [];

  const weightMap: Record<string, number> = {
    lighter: 100,
    '100': 100,
    '200': 200,
    '300': 300,
    '400': 400,
    regular: 400,
    normal: 400,
    '500': 500,
    '600': 600,
    bold: 700,
    bolder: 800,
    '700': 700,
    '800': 800,
    '900': 900,
  };

  fonts.forEach(font => {
    Object.entries(font.files).forEach(([weightKey, url]) => {
      if (!url) return;

      const fontURL = replaceHttpWithHttps(url);
      const weight = weightMap[weightKey];

      if (weight === undefined) return;

      fontFaces.push(`
          @font-face {
            font-family: '${font.value}';
            src: url('${fontURL}') format('truetype');
            font-weight: ${weight};
            font-style: "normal";
            font-display: swap;
          }
        `);
    });
  });
  return fontFaces.join('\n');
};
